export default __webpack_public_path__ + "static/media/facebook.cd4df485.svg";